import { Phone, MapPin } from "lucide-react";

const Footer = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer id="contact" className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* Company Info */}
          <div>
            <div className="mb-4">
              <h3 className="text-2xl font-bold">
                <span className="text-[#1a7a8a]">BSJ</span>{" "}
                <span className="text-[#1a7a8a]">GROUP</span>
              </h3>
              <p className="text-xs text-gray-400 uppercase tracking-wider">
                Renovations
              </p>
            </div>
            <p className="text-gray-400 mb-4">
              Your trusted partner for professional home renovation and improvement services in Amsterdam.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection("services")}
                  className="text-gray-400 hover:text-[#1a7a8a] transition-colors"
                >
                  Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("projects")}
                  className="text-gray-400 hover:text-[#1a7a8a] transition-colors"
                >
                  Projects
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("testimonials")}
                  className="text-gray-400 hover:text-[#1a7a8a] transition-colors"
                >
                  Testimonials
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("quote")}
                  className="text-gray-400 hover:text-[#1a7a8a] transition-colors"
                >
                  Get Quote
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold mb-4">Our Services</h4>
            <ul className="space-y-2 text-gray-400">
              <li>House Renovation</li>
              <li>Bathroom Renovation</li>
              <li>Painting</li>
              <li>Plumbing</li>
              <li>Plastering</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start">
                <Phone className="text-[#1a7a8a] mr-3 flex-shrink-0 mt-1" size={20} />
                <a href="tel:0031615460576" className="text-gray-400 hover:text-[#1a7a8a] transition-colors">
                  0031615460576
                </a>
              </li>
              <li className="flex items-start">
                <MapPin className="text-[#1a7a8a] mr-3 flex-shrink-0 mt-1" size={20} />
                <span className="text-gray-400">
                  Othho Heldringstraat 326<br />Amsterdam
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="text-center text-gray-400">
            <p>&copy; {new Date().getFullYear()} Basic Job. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
